import { LoaderFunctionArgs, Outlet } from 'react-router';

import { TCustomRouteObject, THandle } from '@/shared/types/router.types';
import { UserFragment } from '@/shared/types/types.generated';

export const userInnerRoutes: TCustomRouteObject[] = [
  {
    path: ':userId/:tabId?',
    lazy: async () => {
      const { UserRoute } = await import('./user');
      return { Component: UserRoute };
    },
    shouldRevalidate: () => false,
    loader: async (args: LoaderFunctionArgs) => {
      const { userLoader } = await import('./user');
      return userLoader(args);
    },
    handle: {
      crumb: {
        label: (data: UserFragment) => `${data.firstName} ${data.lastName}`,
      },
    },
  },
];

export const userRouteHandle: THandle = {
  crumb: {
    label: 'users',
    localized: true,
  },
  permission: { action: 'ident:readUser' },
};

export const userRoutes: TCustomRouteObject = {
  path: '/users',
  Component: () => <Outlet />,
  handle: userRouteHandle,
  children: [
    {
      index: true,
      lazy: async () => {
        const { UsersListRoute } = await import('./users');
        return { Component: UsersListRoute };
      },
    },
    ...userInnerRoutes,
  ],
};
